// extracted by mini-css-extract-plugin
export default {"main":"Timeline_main__gE1nk","chrono":"Timeline_chrono__C5Qxj"};